// Anzeige-Zustand der Büro-Rechner (ComputerMenu). GET /api/computers liefert
// je Rechner den Online-Status, den der Büro-Dienst alle ~30 s meldet, und den
// letzten Auftrag der letzten 10 min; daraus ergibt sich, was der Knopf zeigt.

// Wie _AGENT_DOWN_AFTER im Backend (main.py)
export const AGENT_DOWN_MS = 2 * 60 * 1000;

const RUNNING = ["offen", "laeuft"];

export const STATE_TEXT = {
  on: "läuft",
  off: "aus",
  starting: "startet…",
  stopping: "wird ausgeschaltet…",
  shutting: "fährt herunter",
};

export function isJobRunning(job) {
  return !!job && RUNNING.includes(job.status);
}

// Nach Ergebnis "ok" zeigt der Knopf den Übergang nur so lange, wie er normal
// dauert, danach zählt wieder der gemeldete Online-Status. Bootet ein Rechner
// nicht (WoL nach Stromausfall aus) oder bricht jemand das Herunterfahren ab
// (shutdown /a), gibt es so wieder "Starten" bzw. "Ausschalten".
export const WAKE_SETTLE_MS = 3 * 60 * 1000;     // Booten + Statusmeldung alle 30 s
export const SHUTDOWN_SETTLE_MS = 4 * 60 * 1000; // 60 s Vorwarnung + Herunterfahren + Statusmeldung

/** Millisekunden seit dem Ergebnis (ersatzweise seit dem Auftrag). */
function sinceDone(job, now) {
  const t = Date.parse(job.done_at || job.created_at || "");
  return Number.isFinite(t) ? now - t : Infinity;
}

/** on | off | starting | stopping | shutting */
export function computerState(c, now = Date.now()) {
  const job = c.job;
  // Auftrag wartet auf den Büro-Dienst oder wird gerade ausgeführt
  if (isJobRunning(job)) return job.kind === "wake" ? "starting" : "stopping";
  if (job && job.status === "ok") {
    const age = sinceDone(job, now);
    // Wecksignal ist raus, der Rechner bootet bis zur nächsten Statusmeldung
    if (job.kind === "wake" && !c.online && age < WAKE_SETTLE_MS) return "starting";
    // shutdown /t 60: bis er offline gemeldet wird
    if (job.kind === "shutdown" && c.online && age < SHUTDOWN_SETTLE_MS) return "shutting";
  }
  return c.online ? "on" : "off";
}

/** Startet/fährt herunter/Auftrag läuft: dann schneller nachladen. */
export function isTransitional(state) {
  return state !== "on" && state !== "off";
}

/** Büro-Dienst hat sich nie oder seit über 2 min nicht gemeldet. */
export function isAgentDown(seenAt, now = Date.now()) {
  const t = seenAt ? Date.parse(seenAt) : NaN;
  return !Number.isFinite(t) || now - t > AGENT_DOWN_MS;
}
